import React, {
    Component,
    useState
} from 'react'
import moment from 'moment-timezone';

const XDate = (props) => {
    return (
        <div className="xdate">
            <div className="xdate-label">
                {props.label}
            </div>
            <div className="xdate-value">
                {moment(props.value).tz(moment.tz.guess()).format('MMM D, YYYY hh:mma z')}
            </div>
        </div>
    );
}

export default XDate;